export const cornerRadius = {
  xs: 2,
  s: 4,
  m: 8,
  l: 12,
  xl: 16,
  '2xl': 32,
  '3xl': 48,
  circle: 1000
}

export type CornerRadius = typeof cornerRadius
export type CornerRadiusOptions = keyof CornerRadius
